import { Search } from "lucide-react";
import { Input } from "@/components/ui/input";

interface SearchBarProps {
  value: string;
  onChange: (value: string) => void;
}

export function CampaignSearchBar({ value, onChange }: SearchBarProps) {
  return (
    <div className="flex-1 relative">
      <Search className="absolute left-3 top-1/2 transform -translate-y-1/2 h-4 w-4 text-muted-foreground" />
      <Input
        placeholder="Search campaigns..."
        value={value}
        onChange={(e) => onChange(e.target.value)}
        className="w-full pl-9"
      />
    </div>
  );
}